import React, {Component} from 'react';
import './menu.css';

export default class Menu extends Component {
    constructor(props){
        super(props);
        this.wrapperRef = React.createRef();
    }
    handleClick() {
        const wrapper = this.wrapperRef.current;
        wrapper.classList.toggle('is-nav-open')
    }
    render() {
        return (
            <div className="hamburger-menu">
            <input id="menu__toggle" type="checkbox" />
            <label className="menu__btn" htmlFor="menu__toggle">
              <span></span>
            </label>
            <ul className="menu__box">
              <li><a className="menu__item" href="#features">Features</a></li>
              <li><a className="menu__item" href="#roadmap">RoadMap</a></li>
              <li><a className="menu__item" href="#business">Business model</a></li>
              <li><a className="menu__item" href="#partners">Partners</a></li>
            </ul>
          </div>
        );
    }
}